// ─────────────────────────────────────────────────────────────
// useLocalStorage
// Extracted from App.js.
// ─────────────────────────────────────────────────────────────

import { useCallback, useState } from "react";

export function useLocalStorage(key, init) {
  const [val, setVal] = useState(() => {
    try { const s = localStorage.getItem(key); return s ? JSON.parse(s) : init; } catch { return init; }
  });
  const set = useCallback(v => {
    setVal(v);
    try { localStorage.setItem(key, JSON.stringify(v)); } catch {}
  }, [key]);
  return [val, set];
}

// ─────────────────────────────────────────────────────────────
// AUTH HOOK - FIXED
// ─────────────────────────────────────────────────────────────
